import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import theme from '@anvilco-pkg/ui/theme'
import media from '@anvilco-pkg/ui/media'

import Brand from '@anvilco-pkg/ui/components/Brand'

/**
 *
 * FOR WHATEVER REASON:
 * This component is ripped from the ui package. It should not be here, but when building
 * the site in Vercel, it wreaks havoc on the site visually. The VideoModal gets rendered
 * with styles from this component, and it's not clear why. Other places on the site also
 * get their styles messed up, but the VideoModal is the most noticeable.
 *
 * TODO: fix this mess.
 *
 */

const CopyrightContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding-top: 60px;
  padding-bottom: 60px;

  .sep {
    display: none;
  }

  ${media.desktop`
    padding-top: 60px;
    padding-bottom: 60px;
  `}
`

const Container = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.black};
  font-size: 16px;

  .sep {
    display: none;
  }

  ${media.desktop`
    flex-direction: row;

    .sep {
      display: block;
    }
  `}
`

const ContactContainer = styled.div`
  display: flex;
  flex-direction: row;

  > * {
    display: block;
    margin-right: 10px;
  }

  ${media.tablet`
    margin-left: 15px;
  `}
`

const BottomBrand = styled.a`
  display: none;
  margin-right: 15px;

  ${media.desktop`
    display: block;
  `}
`

const ContactLink = styled.a`
  color: ${theme.colors.black};
`

// passing to into 'to' and 'href' for now, app still needs href... I think
// we should ONLY support 'to' in the future - marketing site does this in UniversalLink
const PublicFooter = ({ linkComponent, ...others }) => {
  const LinkComponent = linkComponent

  return (
    <CopyrightContainer {...others}>
      <Container>
        <BottomBrand as={LinkComponent} to="/">
          <Brand />
        </BottomBrand>
        <span style={{ marginLeft: '10px', marginRight: '10px' }}>
          © {new Date().getFullYear()}
        </span>
        <span className="sep">|</span>
        <ContactContainer>
          <ContactLink as={LinkComponent} to="mailto:hello@useanvil.com">
            hello@useanvil.com
          </ContactLink>
          <span className="sep">|</span>
          <ContactLink as={LinkComponent} to="/contact-sales/">
            Contact sales
          </ContactLink>
        </ContactContainer>
      </Container>
    </CopyrightContainer>
  )
}

export default PublicFooter

PublicFooter.propTypes = {
  // linkComponent MUST take a 'to' prop, that will automatically pass the correct href to the link
  linkComponent: PropTypes.elementType.isRequired,
}
